(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["riot-world-hero"] && !Shopify.designMode) return;
  try {
    
  function initializeRiotWorld(root) {
    root.querySelectorAll('[data-riot-world]').forEach(function(section) {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      var video = section.querySelector('video');
      var button = section.querySelector('[data-world-toggle]');
      var mobile = window.matchMedia('(max-width: 767px)');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      var userPaused = reduced.matches;
      function reflect() {
        button.textContent = video.paused ? button.dataset.play : button.dataset.pause;
        button.setAttribute('aria-pressed', String(!video.paused));
      }
      function play() {
        var result = video.play();
        if (result) result.catch(reflect);
      }
      function selectSource() {
        video.poster = mobile.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
        var source = mobile.matches ? video.dataset.mobile : video.dataset.desktop;
        if (video.getAttribute('src') !== source && !reduced.matches) {
          video.src = source;
          video.muted = true;
          video.load();
          if (!userPaused) play();
        }
      }
      video.addEventListener('play', reflect);
      video.addEventListener('pause', reflect);
      video.addEventListener('error', reflect);
      button.addEventListener('click', function() {
        if (video.paused) {
          userPaused = false;
          if (!video.getAttribute('src')) video.src = mobile.matches ? video.dataset.mobile : video.dataset.desktop;
          play();
        } else {
          userPaused = true;
          video.pause();
        }
      });
      mobile.addEventListener('change', selectSource);
      reduced.addEventListener('change', function() {
        if (reduced.matches) { userPaused = true; video.pause(); }
        else selectSource();
      });
      selectSource();
      reflect();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { initializeRiotWorld(document); });
  else initializeRiotWorld(document);
  document.addEventListener('shopify:section:load', function(event) { initializeRiotWorld(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vip-countdown"] && !Shopify.designMode) return;
  try {
    
function initializeVipCountdown(root) {
  if (!root || root.dataset.countdownInitialized === 'true') return;
  root.dataset.countdownInitialized = 'true';

  const end = Date.parse(root.dataset.end);
  const timer = root.querySelector('.vip-countdown__timer');
  const days = root.querySelector('[data-vip-days]');
  const hours = root.querySelector('[data-vip-hours]');
  const minutes = root.querySelector('[data-vip-minutes]');
  const seconds = root.querySelector('[data-vip-seconds]');

  if (!Number.isFinite(end) || !timer || !days || !hours || !minutes || !seconds) return;

  const pad = value => String(value).padStart(2, '0');

  const update = () => {
    const remaining = Math.max(0, end - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const dayValue = Math.floor(totalSeconds / 86400);
    const hourValue = Math.floor((totalSeconds % 86400) / 3600);
    const minuteValue = Math.floor((totalSeconds % 3600) / 60);
    const secondValue = totalSeconds % 60;

    days.textContent = pad(dayValue);
    hours.textContent = pad(hourValue);
    minutes.textContent = pad(minuteValue);
    seconds.textContent = pad(secondValue);
    timer.setAttribute(
      'aria-label',
      dayValue + ' ' + root.dataset.days + ', ' +
      hourValue + ' ' + root.dataset.hours + ', ' +
      minuteValue + ' ' + root.dataset.minutes + ', ' +
      secondValue + ' ' + root.dataset.seconds
    );

    if (remaining === 0) {
      root.querySelector('.vip-countdown__heading').textContent = root.dataset.expired;
      timer.hidden = true;
      clearInterval(interval);
    }
  };

  let interval;
  update();
  interval = setInterval(update, 1000);
}

document.querySelectorAll('.vip-countdown').forEach(initializeVipCountdown);
document.addEventListener('shopify:section:load', event => {
  initializeVipCountdown(event.target.querySelector('.vip-countdown'));
});

  } catch(e) { console.error(e); }
})();
})();
